//# sourceMappingURL=mode.mjs.map
/// <reference types="./mode.d.mts" />
import { Ok, CustomType as $CustomType } from "../gleam.mjs";
import { read } from "./mode.ffi.mjs";

export class Production extends $CustomType {}
export const Mode$Production = () => new Production();
export const Mode$isProduction = (value) => value instanceof Production;

export class Staging extends $CustomType {}
export const Mode$Staging = () => new Staging();
export const Mode$isStaging = (value) => value instanceof Staging;

export class Development extends $CustomType {}
export const Mode$Development = () => new Development();
export const Mode$isDevelopment = (value) => value instanceof Development;

export class Cypress extends $CustomType {}
export const Mode$Cypress = () => new Cypress();
export const Mode$isCypress = (value) => value instanceof Cypress;

/**
 * Read the mode set at build or runtime. Any mode can be set with the CLI,
 * by using `--mode [mode-name]`. Steerlab only supports `development`,
 * `staging` and `production`.
 *
 * Defaults to `Production` if nothing can be read.
 */
export function mode() {
  let $ = read();
  if ($ instanceof Ok) {
    let $1 = $[0];
    if ($1 === "cypress") {
      return new Cypress();
    } else if ($1 === "development") {
      return new Development();
    } else if ($1 === "staging") {
      return new Staging();
    } else if ($1 === "production") {
      return new Production();
    } else {
      return new Production();
    }
  } else {
    return new Production();
  }
}

/**
 * `True` when running in development, with the webserver.
 */
export function dev() {
  let $ = mode();
  if ($ instanceof Production) {
    return false;
  } else if ($ instanceof Staging) {
    return false;
  } else if ($ instanceof Development) {
    return true;
  } else {
    return true;
  }
}

/**
 * `True` when running on Cypress, `False` otherwise.
 */
export function cypress() {
  let $ = mode();
  if ($ instanceof Production) {
    return false;
  } else if ($ instanceof Staging) {
    return false;
  } else if ($ instanceof Development) {
    return false;
  } else {
    return true;
  }
}
